import { useState, useEffect, useCallback } from "react";
import api from "../api/axios";

export default function useSharedMass() {
    const [accounts, setAccounts] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchSharedAccounts = useCallback(async () => {
        setIsLoading(true);
        try {
            const response = await api.get("/gmails"); 
            setAccounts(response.data);
            setError(null);
        } catch (err) {
            console.error("Error fetching shared mass data:", err);
            setError("Failed to sync with database.");
        } finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchSharedAccounts();
    }, [fetchSharedAccounts]);

    return { accounts, isLoading, error, refresh: fetchSharedAccounts };
}